import { render, staticRenderFns } from "./clusterTable.vue?vue&type=template&id=68dbe92f&"
import script from "./clusterTable.vue?vue&type=script&lang=js&"
export * from "./clusterTable.vue?vue&type=script&lang=js&"
import style0 from "./clusterTable.vue?vue&type=style&index=0&id=68dbe92f&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports